module.exports = __webpack_public_path__ + "img/main-04-02.306b3767.png";